export default __webpack_public_path__ + "static/media/flyingLogo.59d89c48.svg";